
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MosaicTilesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (80 + layerIndex * 40) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    const noise = this.pseudoRandom(Math.floor(x) + Math.floor(y));
                    ctx.globalAlpha = (0.1 + noise * 0.3) / (layerIndex + 1);
                    const s = spacing * 0.8 * scale;
                    ctx.fillRect(x - s/2, y - s/2, s, s);
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
